import { gql } from "lib/apolloClient";
import {
  curriculumProgramFragment,
  plannerElementSetFragment,
  genericPlannerElementSetFragment,
} from "modules/CommonFragments";

export const getPlatformUserSessionDetailsQuery = gql`
  query getPlatformUserDetails($id: ID!, $type: ENTITY_TYPE_ENUM!) {
    node(id: $id, type: $type) {
      id
      ... on Staff {
        id
        isSessionVerified
        isImpersonated
      }
      ... on Student {
        id
        isSessionVerified
        isImpersonated
      }
      ... on FamilyMember {
        id
        isSessionVerified
      }
    }
  }
`;

export const getDefaultAccountManagerDetailsQuery = gql`
  query getDefaultAccountManagerDetails {
    globalConstants {
      defaultAccountMangerDetails
    }
  }
`;

export const getOrganizationCurriculumProgramsQuery = gql`
  query getOrganizationCurriculumPrograms($organizationId: ID!) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        curriculumPrograms {
          id
          label
          acronym
          programDataLanguages
          isPrimary
          academicSetupType
          programType
          logo
          academicProgram {
            id
          }
          terms {
            totalCount
          }
          academicYears {
            id
            startDate
            endDate
            isCurrentAcademicYear
            isUpcomingAcademicYear
            isPreviousAcademicYear
            label
          }
          attachments {
            id
            url
          }
          ...subscriptionPlanDetailsItem
          ... on IbMypCurriculumProgram {
            id
            nodeInterfaceType
            type
            plannerElementSets {
              ...plannerElementSetBasicDetailsItem
            }
          }
          ... on IbPypCurriculumProgram {
            id
            nodeInterfaceType
            type
            plannerElementSets {
              ...genericPlannerElementSetBasicDetailsItem
            }
          }
          ... on UBDCurriculumProgram {
            id
            variant
            nodeInterfaceType
            type
            presetSubjectMap
            plannerElementSets {
              ...plannerElementSetBasicDetailsItem
            }
          }
          ... on IbDpCurriculumProgram {
            id
            nodeInterfaceType
            type
            examSessionMonth
            plannerElementSets {
              ...plannerElementSetBasicDetailsItem
            }
          }
        }
      }
    }
  }
  ${curriculumProgramFragment.subscriptionPlanDetails}
  ${plannerElementSetFragment.plannerElementSetBasicDetails}
  ${genericPlannerElementSetFragment.basicDetails}
`;

export const getAccountProgramDetailsQuery = gql`
  query getAccountProgramDetails(
    $organizationId: ID!
    $curriculumProgramFilters: CurriculumProgramFilters
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        curriculumPrograms(filters: $curriculumProgramFilters) {
          id
          label
          acronym
          programDataLanguages
          programType
          logo
          attachments {
            id
            url
          }
          academicYears {
            id
            startDate
            endDate
            isCurrentAcademicYear
            isUpcomingAcademicYear
            isPreviousAcademicYear
          }
        }
      }
    }
  }
`;

export const getAcademicProgramDetailsQuery = gql`
  query getAcademicProgramDetails(
    $organizationId: ID!
    $curriculumProgramFilters: CurriculumProgramFilters
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        curriculumPrograms(filters: $curriculumProgramFilters) {
          id
          label
          acronym
          programDataLanguages
          academicSetupType
          programType
          ... on IbMypCurriculumProgram {
            id
            nodeInterfaceType
            type
            plannerElementSets {
              ...plannerElementSetBasicDetailsItem
            }
          }
          ... on IbPypCurriculumProgram {
            id
            nodeInterfaceType
            type
            plannerElementSets {
              ...genericPlannerElementSetBasicDetailsItem
            }
          }
          ... on UBDCurriculumProgram {
            id
            variant
            nodeInterfaceType
            type
            presetSubjectMap
            plannerElementSets {
              ...plannerElementSetBasicDetailsItem
            }
          }
          ... on IbDpCurriculumProgram {
            id
            nodeInterfaceType
            type
            plannerElementSets {
              ...plannerElementSetBasicDetailsItem
            }
          }
        }
      }
    }
  }
  ${plannerElementSetFragment.plannerElementSetBasicDetails}
  ${genericPlannerElementSetFragment.basicDetails}
`;

export const getFamilySelectedChildYearGroupQuery = gql`
  query getFamilySelectedChildYearGroupQuery($id: ID!) {
    node(id: $id, type: STUDENT) {
      ... on Student {
        id
        yearGroup {
          id
          grade {
            id
          }
        }
      }
    }
  }
`;
